import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 0.75rem;
  text-transform: uppercase;

  .title {
    color: white;
    font-family: 'Lato';
    font-size: 1rem;
  }
`;

export const Icon = styled.div`
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Lato';
  font-size: 2rem;

  padding: 0.5rem;

  & span {
    font-size: 1rem;
    padding-right: 0.5rem;
    white-space: nowrap;
  }

  &.disabled {
    color: grey;
  }
`;

/* *********************************************** */

interface IndexProp {
  borderColour?: string;
}

export const Index = styled.div<IndexProp>`
  background-color: ${({ borderColour, theme }) =>
    borderColour || theme.qfb4Dark};
  position: relative;
  width: 32px;
  min-width: 32px;
  padding: 2.25rem 0;

  span {
    color: white;
    font-size: ${({ theme }) => theme.fontSizeSmall};
    font-family: 'Lato';
    position: absolute;
    transform: translate(-50%, -50%) rotate(270deg);
    left: 50%;
    top: 50%;
    white-space: nowrap;
  }
`;

interface BannerProp {
  borderColourHover?: string;
}

export const Banner = styled.div<BannerProp>`
  background: rgba(0, 0, 0, 0.5);
  border-right: 0.25rem solid
    ${({ borderColourHover, theme }) => borderColourHover || theme.qfb5};
  display: flex;
  flex-flow: row;
  margin-top: 1.5rem;

  -webkit-box-shadow: 5px 5px 15px -8px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 5px 5px 15px -8px rgba(0, 0, 0, 0.75);
  box-shadow: 5px 5px 15px -8px rgba(0, 0, 0, 0.75);

  &.disabled {
    cursor: default;
    background: black;
    ${Index} {
      background-color: ${({ borderColourHover, theme }) =>
        borderColourHover || theme.qfb4};
    }
  }
  &:hover {
    background: black;
    ${Index} {
      background-color: ${({ borderColourHover, theme }) =>
        borderColourHover || theme.qfb4};
    }
  }
`;
